<template>
  <el-dialog
    title="辅助核算转化"
    class="newDialog"
    append-to-body
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="600px"
    >
    <div class="AI_choice_dialog" v-loading="loading">
      <div class="AI_choice_dialog-tips">检查到该列有无法判断的字段，请赋予含义代表该列辅助核算类型是“开启”或“关闭”：</div>
      <div class="AI_choice_dialog-tableList">
        <public-table  :table="tableData">
          <!-- 处理数据 -->
          <template slot-scope="props" slot="meaning">
            <div style="height: 21px;">
              <el-switch
                style="display: block"
                v-model="props.scope.row.meaning"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="开启"
                inactive-text="关闭">
              </el-switch>
            </div>
          </template>
        </public-table>
      </div>
      <div class="AI_choice_dialog-footer">
        <acc-btn text="取消" type="2" @click="dialogVisible=false"></acc-btn>
        <acc-btn @click="handleEventSave" ></acc-btn>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import publicTable from '@/components/publicTable'
  export default {
    components:{
      publicTable
    },
    data() {
      return {
        dialogVisible:false,
        loading:false,
        tableData: {
        	border: true,				// 是否带有纵向边框
        	stripe: true,				// 是否带有斑马纹
        	loading: false,				// 是否显示加载动画
        	hasSelect: false,			// 是否显示多选
        	hasOperation: false,		// 是否有操作功能
        	hasContextmenu: false,		// 是否有右键功能
        	hasShowSummary: false,		// 是否显示合计行
        	Maxheight: 500,			// Table最大高度
        	hasShowPagination: false,	// 是否显示分页
        	config: [
            {
            	label: '字段',
            	value: 'value',
              width:"180",
            	show: 'normal'
            },{
            	label: '代表该辅助核算类型',
            	value: 'meaning',
            	show: 'template'
            }
          ],
        	data: [],
        	page: {
        		pageNo: 1,
        		pageSize: 20,
        		count: 10
        	},
        	center: {
        		textAlign: 'center',
        		padding: '6px 0'
        	}
        },
      }
    },
    methods:{
      //提交选择
      handleEventSave() {
        this.$emit("saveChoice",this.tableData.data)
      },
      getTableData(headId) {
        if(!headId) return this.$message.warning("未检测到表头ID")
        this.loading = true;
         this.$http.post('import/getAuxiliaryRule',{ headId })
           .then(
               res=>{
                 this.loading = false;
                 if(res&&res.data.code=="1") {
                   this.tableData.data = res.data.data;
                 }
               }
           )
      }
    }
  }
</script>

<style lang="less">
  .AI_choice_dialog {
    padding: 0 30px 30px;
    &-tableList {
      margin-top: 20px;
    }
    &-tips {
      font-size: 12px;
      color: rgba(255, 48, 73);
    }
    &-footer {
      margin-top: 30px;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AIImport/choiceSwitch.vue